import React, { useState } from 'react';
import { /* useLocation, */ useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Container, Row, Col, Card, CardBody,
} from 'reactstrap';

import { Button /* , ButtonLink */ } from 'components/Button';
import { isValidCode, resolveErrorMessage } from 'utils/aws';
import { completeMfaChallenge /* , switchMfaMethod as switchMfaMethodAction */ } from 'actions/auth';
import CodeInput from './components/CodeInput';
import ShieldIcon from './components/ShieldIcon';
import './style.scss';

const VerifyAuthenticatorCode = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [trustDevice, setTrustDevice] = useState(false);

  const handleVerify = (e) => {
    e.preventDefault();

    if (!isValidCode(code)) {
      setHasError(true);
      return;
    }

    setIsLoading(true);
    setHasError(false);

    dispatch(completeMfaChallenge({
      code,
      trustDevice,
      success: () => {
        setIsLoading(false);
        navigate('/consumer/dashboard');
      },
      fail: (err) => {
        setIsLoading(false);
        setHasError(true);
        toast.error(resolveErrorMessage(err, 'That code did not match. Please try again.'));
      },
      navigate,
    }));
  };

  return (
    <div className="two-factor-page">
      <Container fluid>
        <Row>
          <Col>
            <Card className="tf-card">
              <CardBody className="p-4 text-center">
                <div className="mb-3">
                  <span className="tf-shield"><ShieldIcon /></span>
                </div>

                <h3 className="tf-title">Verify it&apos;s you</h3>
                <p className="tf-subtitle">Enter the 6-digit code from your authenticator app.</p>

                <form onSubmit={handleVerify}>
                  <CodeInput
                    value={code}
                    onChange={(val) => { setCode(val); setHasError(false); }}
                    hasError={hasError}
                    disabled={isLoading}
                    autoFocus
                  />

                  <div className="tf-checkbox">
                    <label className="tf-checkbox__row" htmlFor="trust-device">
                      <input
                        id="trust-device"
                        type="checkbox"
                        checked={trustDevice}
                        onChange={(e) => setTrustDevice(e.target.checked)}
                        disabled={isLoading}
                      />
                      Remember this device for 30 days
                    </label>
                  </div>

                  <Button
                    type="submit"
                    color="primary"
                    className="w-100 mt-3"
                    isLoading={isLoading}
                    onClick={handleVerify}
                  >
                    Verify
                  </Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyAuthenticatorCode;
